import FlashProgressBar from "./FlashProgressBar";
import SystemTabletTopBarLayout from "../../../layouts/SystemTabletTopBarLayout";
import SystemFlashTopBarLogoLayout from "../../../layouts/SystemFlashTopBarLogoLayout";
import SystemFlashLogoImage from "../../../images/SystemFlashLogoImage";
import SystemFlashSelectedGradeBadge from "../../../badges/SystemFlashSelectedGradeBadge";
import {FlashLogoTextSize} from "../../../../controllers/SystemFlashLogoTextController";
import SystemDesktopTabletLeaveFlashButton from "../../../buttons/SystemDesktopTabletLeaveFlashButton";

export default function FlashTabletTopBar({onLeaveFlashPressed,
                                selectedGrade,
                                currentQuestion,
                                totalQuestion}) {
    // Used in MetaFlashScreen to display top bar
    // in mobile mode

    // BUILD
    return (
        <SystemTabletTopBarLayout>
            <SystemFlashTopBarLogoLayout>
                <SystemFlashLogoImage flashLogoSize={FlashLogoTextSize.XSMALL} />
                <SystemFlashSelectedGradeBadge selectedGrade={selectedGrade} />
            </SystemFlashTopBarLogoLayout>
            <FlashProgressBar currentQuestion={currentQuestion}
                              totalQuestion={totalQuestion} />
            <SystemDesktopTabletLeaveFlashButton onLeaveFlashPressed={onLeaveFlashPressed} />
        </SystemTabletTopBarLayout>
    );
}